<template>
  <BaseModal
    :is-editable="false"
    :is-archivable="false"
    :is-visible="isVisible"
    @hideModal="hideModal()"
  >
    <template #header>
        {{ $t('views.agreements.list.options.sendOfferToAccept') }}
    </template>
    <template #body>
      <b-row align-h="around">
        <b-col>
          <button type="button" class="btn btn-danger" @click="hideModal()">{{$t('buttons.cancel')}}</button>
        </b-col>
        <b-col>
          <button type="button" class="btn btn-success float-right" @click="sendOfferToAccept({ decisionUser: 1 })">{{$t('buttons.accept')}}</button>
        </b-col>
      </b-row>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'SendOfferToAcceptModal',
  components: {
    BaseModal
  },
  computed: {
    ...mapGetters({
      isVisible: 'agreements/list/getIsSendOfferToAcceptModalVisible',
      agreementId: 'agreements/list/getSendOfferToAcceptId'
    })
  },
  methods: {
    hideModal () {
      this.toggleSendOfferToAcceptModal()
    },
    ...mapMutations({
      toggleSendOfferToAcceptModal: 'agreements/list/toggleSendOfferToAcceptModal'
    }),
    ...mapActions({
      sendOfferToAccept: 'agreements/list/sendOfferToAccept'
    })
  }
}
</script>
